import React from 'react';
import { Home, Building2, Grid, Droplets, ArrowRight } from 'lucide-react';
import { Card } from './ui/Card';
export function Services() {
  const services = [{
    title: 'Residential Cleaning',
    description: 'Interior & exterior window cleaning for homes of all sizes. We treat your home with care and leave your windows sparkling.',
    icon: Home
  }, {
    title: 'Commercial Cleaning',
    description: 'Reliable service for storefronts, offices, and commercial properties. Make a great first impression on your customers.',
    icon: Building2
  }, {
    title: 'Screen Cleaning',
    description: 'Complete removal, deep cleaning, and reinstallation of window screens to remove dust and allergens.',
    icon: Grid
  }, {
    title: 'Hard Water Removal',
    description: 'Specialized treatment for mineral deposits and hard water stains common in Arizona, restoring glass clarity.',
    icon: Droplets
  }];
  return <section id="services" className="py-20 bg-gray-50" data-id="element-121">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-122">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-124">
            Our Services
          </h2>
          <p className="text-lg text-gray-600" data-id="element-125">
            Comprehensive window care solutions tailored for the Arizona
            climate.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-126">
          {services.map((service, index) => <Card key={index} variant="hover" className="p-8 flex flex-col h-full bg-white border-gray-100" data-id="element-127">
              <div className="h-12 w-12 rounded-lg bg-navy/5 flex items-center justify-center mb-6" data-id="element-128">
                <service.icon className="h-6 w-6 text-navy" data-id="element-129" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-130">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 flex-grow leading-relaxed" data-id="element-131">
                {service.description}
              </p>
              <div className="flex items-center text-gold font-semibold group cursor-pointer" data-id="element-132">
                Learn more{' '}
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-133" />
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}